/** Abholliste zum Mietende (MP-C): Artikel, die noch im Laden sind, obwohl die Buchung beendet ist – abhaken = mitgenommen. */
import { useTx } from "../i18n";
import { useState } from "react";
import { Link } from "react-router";
import { Button, EmptyState, Icon, Notice, Seitenzustand } from "../ui";
import { ItemRow } from "../ui/ItemRow";
import { ApiFehler } from "../api/client";
import { formatEuro } from "@shared/geld";
import { formatTag } from "@shared/zeit";
import { fotoUrl } from "./artikel-api";
import { useStatusMehrere } from "./cockpit-api";
import { useAbholliste } from "./portal-c-api";

export function Abholen() {
  const tx = useTx();
  const q = useAbholliste();
  const status = useStatusMehrere();
  const [haken, setHaken] = useState<Set<string>>(new Set());
  const [meldung, setMeldung] = useState<string | null>(null);
  const toggle = (id: string) => setHaken((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  return (
    <div className="sc-col" style={{ gap: "var(--space-3)" }}>
      <div className="sc-row">
        <Link to="/mieter/regal" className="rg-btn rg-btn--quiet" aria-label="Zurück">‹</Link>
        <h1 className="title">{tx("Abholen")}</h1>
      </div>
      {meldung ? <Notice tone="success">{meldung}</Notice> : null}
      <Seitenzustand query={q} lines={4} thumb istLeer={(d) => d.artikel.length === 0} leer={<EmptyState illustration="all-done" title={tx("Nichts abzuholen")}>Alle deine Artikel sind in einem laufenden Regal oder schon bei dir.</EmptyState>}>
        {(d) => (
          <>
            <Notice tone="attention" title={d.mietende ? `Miete beendet am ${formatTag(d.mietende)}` : "Miete beendet"}>{d.frist ? `Bitte bis ${formatTag(d.frist)} abholen.` : ""} Oder <Link to="/mieter/regal">ein Regal buchen</Link> – dann bleiben die Sachen einfach stehen. Unverkaufte Artikel ohne Abholung gehen nach der Frist an den Laden (siehe Vertrag).</Notice>
            <p className="sc-muted">{d.artikel.length} Artikel · {formatEuro(d.artikel.reduce((a, x) => a + x.preisCent, 0))} · {haken.size} abgehakt</p>
            <div>
              {d.artikel.map((a) => (
                <ItemRow key={a.id} title={a.bezeichnung} photo={fotoUrl(a.fotoKey)} meta={`${a.code} · Regal ${a.regalNummer}`} price={a.preisCent} selected={haken.has(a.id)} onClick={() => toggle(a.id)} action={<span className="mp-kachel-artikel__check" style={{ position: "static" }} aria-hidden="true">{haken.has(a.id) ? <Icon name="check" size={16} /> : null}</span>} />
              ))}
            </div>
            <div className="mp-foot">
              <Button variant="primary" size="lg" block icon="package" loading={status.isPending} disabled={haken.size === 0} onClick={() => status.mutate({ artikelIds: [...haken], status: "abgeholt" }, { onSuccess: (r) => { setMeldung(`${r.geaendert} Artikel als mitgenommen markiert.`); setHaken(new Set()); }, onError: (e) => setMeldung(e instanceof ApiFehler ? e.message : "Das hat nicht geklappt.") })}>Mitgenommen ({haken.size})</Button>
              {haken.size < d.artikel.length ? <Button variant="quiet" block onClick={() => setHaken(new Set(d.artikel.map((a) => a.id)))}>Alle abhaken</Button> : null}
            </div>
          </>
        )}
      </Seitenzustand>
    </div>
  );
}
